import React from 'react';

type Toast = {
  id: number;
  type: 'success' | 'error' | 'info';
  message: string;
};

const Icon = ({ type }: { type: Toast['type'] }) => {
  if (type === 'success') return (
    <svg className="w-5 h-5 text-white mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7"/></svg>
  );
  if (type === 'error') return (
    <svg className="w-5 h-5 text-white mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/></svg>
  );
  return (
    <svg className="w-5 h-5 text-white mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
  );
}

export default function Toasts({
  toasts,
  onRemove,
}: {
  toasts: Toast[];
  onRemove: (id: number) => void;
}) {
  return (
    <div className="fixed bottom-6 right-6 flex flex-col gap-3 z-50 pointer-events-none">
      {toasts.map(t => (
        <div
          key={t.id}
          role="status"
          aria-live="polite"
          className={`max-w-xs w-full px-4 py-3 rounded shadow-lg text-sm text-white flex items-start justify-between transform transition-all duration-300 pointer-events-auto ${
            t.type === 'success' ? 'bg-green-600' : t.type === 'error' ? 'bg-red-600' : 'bg-blue-600'
          }`}
        >
          <div className="flex items-start">
            <Icon type={t.type} />
            <div className="pr-2">{t.message}</div>
          </div>
          <button onClick={() => onRemove(t.id)} className="font-bold ml-2 opacity-90">×</button>
        </div>
      ))}
    </div>
  );
}
